export default "__VITE_ASSET__612f88b4__"